import { render } from "./MathWallet.vue?vue&type=template&id=22cb738c&scoped=true"
import script from "./MathWallet.vue?vue&type=script&lang=js"
export * from "./MathWallet.vue?vue&type=script&lang=js"

import "./MathWallet.vue?vue&type=style&index=0&id=22cb738c&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cb738c"]])

export default __exports__